import React from 'react';
import { Navigate } from 'react-router-dom';
import SuspensePage from '@/app/ui/SuspensePage';

const DashboardHome = React.lazy(() => import('@/pages/dashboard/DashboardHome'));
const Profile = React.lazy(() => import('@/pages/dashboard/Profile'));
const MyRequests = React.lazy(() => import('@/pages/dashboard/MyRequests'));
const MyAppointments = React.lazy(() => import('@/pages/dashboard/MyAppointments'));
const DirectMessages = React.lazy(() => import('@/pages/dashboard/DirectMessages'));
const CompanyInfo = React.lazy(() => import('@/pages/dashboard/CompanyInfo'));
const CartPage = React.lazy(() => import('@/pages/dashboard/CartPage'));
const FavoritesPage = React.lazy(() => import('@/pages/dashboard/FavoritesPage'));
const MyPurchaseRequestsPage = React.lazy(() => import('@/pages/dashboard/MyPurchaseRequestsPage'));
const LoyaltyPage = React.lazy(() => import('@/pages/dashboard/LoyaltyPage'));
const MyAnnoncesPage = React.lazy(() => import('@/pages/dashboard/MyAnnoncesPage'));
const AnnonceDetailPage = React.lazy(() => import('@/pages/dashboard/AnnonceDetailPage'));
const AnnoncesPublicPage = React.lazy(() => import('@/pages/dashboard/AnnoncesPublicPage'));
const MyResponsesPage = React.lazy(() => import('@/pages/dashboard/MyResponsesPage'));
const ProfessionalProfilePage = React.lazy(() => import('@/pages/dashboard/ProfessionalProfilePage'));
const NotificationSettings = React.lazy(() => import('@/pages/dashboard/NotificationSettings'));

const clientRoutes = [
  { index: true, element: <Navigate to="/client/dashboard" replace /> },
  {
    path: 'dashboard',
    element: (
      <SuspensePage>
        <DashboardHome />
      </SuspensePage>
    ),
  },
  {
    path: 'profile',
    element: (
      <SuspensePage>
        <Profile />
      </SuspensePage>
    ),
  },
  {
    path: 'requests',
    element: (
      <SuspensePage>
        <MyRequests />
      </SuspensePage>
    ),
  },
  {
    path: 'appointments',
    element: (
      <SuspensePage>
        <MyAppointments />
      </SuspensePage>
    ),
  },
  {
    path: 'messages',
    element: (
      <SuspensePage>
        <DirectMessages />
      </SuspensePage>
    ),
  },
  {
    path: 'company',
    element: (
      <SuspensePage>
        <CompanyInfo />
      </SuspensePage>
    ),
  },
  {
    path: 'cart',
    element: (
      <SuspensePage>
        <CartPage />
      </SuspensePage>
    ),
  },
  {
    path: 'favorites',
    element: (
      <SuspensePage>
        <FavoritesPage />
      </SuspensePage>
    ),
  },
  {
    path: 'my-purchases',
    element: (
      <SuspensePage>
        <MyPurchaseRequestsPage />
      </SuspensePage>
    ),
  },
  {
    path: 'fidelite',
    element: (
      <SuspensePage>
        <LoyaltyPage />
      </SuspensePage>
    ),
  },
  {
    path: 'my-annonces',
    element: (
      <SuspensePage>
        <MyAnnoncesPage />
      </SuspensePage>
    ),
  },
  {
    path: 'my-annonces/:annonceId',
    element: (
      <SuspensePage>
        <AnnonceDetailPage />
      </SuspensePage>
    ),
  },
  {
    path: 'annonces',
    element: (
      <SuspensePage>
        <AnnoncesPublicPage />
      </SuspensePage>
    ),
  },
  {
    path: 'my-responses',
    element: (
      <SuspensePage>
        <MyResponsesPage />
      </SuspensePage>
    ),
  },
  {
    path: 'professional/:professionalId',
    element: (
      <SuspensePage>
        <ProfessionalProfilePage />
      </SuspensePage>
    ),
  },
  {
    path: 'settings/notifications',
    element: (
      <SuspensePage>
        <NotificationSettings />
      </SuspensePage>
    ),
  },
];

export default clientRoutes;
